import styled from "styled-components";

export const PreviewImage = styled.img`
  border-radius: 8px;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  object-position: center;
`;
